import { Chip, ChipProps } from '@mui/material';

export type LogChipColor = Extract<
  ChipProps['color'],
  'default' | 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error'
>;

/** 2xx success, 3xx info, 4xx warning, 5xx error, anything else default. */
export const httpStatusColor = (status: number): LogChipColor => {
  if (status >= 200 && status < 300) {
    return 'success';
  }
  if (status >= 300 && status < 400) {
    return 'info';
  }
  if (status >= 400 && status < 500) {
    return 'warning';
  }
  if (status >= 500 && status < 600) {
    return 'error';
  }
  return 'default';
};

/** An nginx error-log level. */
export const logLevelColor = (level: string): LogChipColor => {
  switch (level.toLowerCase()) {
    case 'info':
    case 'notice':
      return 'info';
    case 'warn':
      return 'warning';
    case 'error':
    case 'crit':
    case 'alert':
    case 'emerg':
      return 'error';
    default:
      return 'default';
  }
};

interface LogChipProps {
  label: string;
  color: LogChipColor;
}

/** The colour is the outline only; the label stays text.primary for contrast. */
export const LogChip = ({ label, color }: LogChipProps) => (
  <Chip component="span" size="small" variant="outlined" color={color} label={label} sx={{ color: 'text.primary' }} />
);
